export enum User {
    TOKEN = 'token',
    USER = 'user',
}
